import { Component } from '@angular/core';
import { Application } from '@modules/common/types/application';
import { SidebarSplitViewKey } from '@modules/common/types/sidebar-split-view-key';

@Component({
  selector: 'app-files-layout',
  templateUrl: './files-layout.component.html',
  styleUrls: ['./files-layout.component.less', '../../styles.less'],
  standalone: false,
})
export class FilesLayoutComponent {
  public readonly sidebarSplitViewKey = SidebarSplitViewKey;
  protected readonly app = Application.files;
}
